module.exports = __webpack_public_path__ + "static/media/prin-last.3f788531.svg";